module.exports = __webpack_public_path__ + "img/Mode_Selector_KingOfTable.cf5c3c99.png";